import { Component, NgModule } from '@angular/core';
import { VERSION } from '@angular/core';
import { EnvService } from './service/system/env-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'dialog-reviewer';

  constructor( private env: EnvService){
    console.log(env.baseUrl);
    console.log("Angular version: ", VERSION.full);
  }
}
